export default __webpack_public_path__ + "static/media/property_1_24.1abd0797.webp";